import React from 'react'
import PropTypes from 'prop-types'

// Components
import Link from 'ui/Link'

// Styles
import './Breadcrumb.scss'

export const Breadcrumb = ({ items = [] }) => {
  return (
    <nav className="x-breadcrumb">
      <ol className="breadcrumb">
        {items.map((item, index) => (
          <li key={index} className="breadcrumb-item">
            <Link
              id={item.id}
              path={item.path}
              params={item.params}
              query={item.query}
              className="link"
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  )
}

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      path: PropTypes.string,
      params: PropTypes.object,
      query: PropTypes.object,
    })
  ),
}

Breadcrumb.defaultProps = {
  items: [],
}

export default Breadcrumb
